// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import styled from '@emotion/styled';

import { withTheme } from 'emotion-theming';

import { disabledColor, successColor, white } from '@zego/theme';

const CustomRadio = styled('span')(
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    border: `1px solid ${disabledColor(4)}`,
    background: white,
    color: disabledColor(10),
    textAlign: 'center',
    fontWeight: 'normal',
    textTransform: 'none',
    fontSize: 16,
    height: 56,
  },
  props => {
    const { segmentedRadioOverrides = {} } = props.theme;
    const { borderRadius = 8, ...restOverrides } = segmentedRadioOverrides;

    return {
      borderTopLeftRadius: props.isFirst ? borderRadius : 0,
      borderBottomLeftRadius: props.isFirst ? borderRadius : 0,
      borderTopRightRadius: props.isLast ? borderRadius : 0,
      borderBottomRightRadius: props.isLast ? borderRadius : 0,
      borderLeftWidth: props.isFirst ? 1 : 0,
      ...restOverrides,
    };
  },
  props => ({
    [`${Radio}:checked + &`]: {
      color: white,
      backgroundColor: props.theme.tintColor || successColor(5),
    },
  }),
);

const RadioLabel = styled('label')(
  {
    display: 'block',
    cursor: 'pointer',
  },
  ({ numChoices }) => ({
    width: `calc(100% / ${numChoices})`,
  }),
);

const Radio = styled('input')({
  position: 'absolute',
  opacity: 0,
  width: 0,
  padding: 0,
  height: 0,
});

const SegmentedChoiceButton = ({
  className,
  name,
  checked,
  value,
  label,
  onChange,
  numChoices,
  isFirst,
  isLast,
}) => (
  <RadioLabel className={className} numChoices={numChoices}>
    <Radio
      checked={checked}
      onChange={onChange}
      value={value}
      type="radio"
      name={name}
    />
    <CustomRadio isFirst={isFirst} isLast={isLast}>
      {label}
    </CustomRadio>
  </RadioLabel>
);

export default withTheme(SegmentedChoiceButton);
